import { setCookie, getLocalStorage, setLocalStorage, removeLocalStorage, getCookie, removeToken, removeCookie } from '@/utils/cache'
import { getToken, setToken } from "@/utils";
import { agentDetail } from '@/api/auth'
import {
  getUserEntList,
  getInfo,
  logout
} from "@/api/admin";
import tagsView from '../module/tagsView'
import config from '../../api/config';
const state = {
  breadcrumb: [],
  agentInfo: getLocalStorage('agentInfo') ? JSON.parse(getLocalStorage('agentInfo')) : null,
  userEnt: getLocalStorage('userEnt') ? JSON.parse(getLocalStorage('userEnt')) : null,
  scopeId: getLocalStorage('scopeId'),
  isAgent: getCookie('isAgent'),
  token: getToken(),
  roles: [],
  userInfo: getLocalStorage('userInfo') ? JSON.parse(getLocalStorage('userInfo')) : null,
  sidebarMenu: getLocalStorage('sidebarMenu') ? JSON.parse(getLocalStorage('sidebarMenu')) : [],
  showLock: sessionStorage.getItem('showLock') == 1 ? true : false,
  judgeRouteShowObj: getLocalStorage('routeShowObj') ? JSON.parse(getLocalStorage('routeShowObj')) : {},
  userEntList: getLocalStorage('userEntList') ? JSON.parse(getLocalStorage('userEntList')) : null,
  allMenu: [
    {
      iconUrl: 'el-icon-document',
      id: 1,
      name: '首页',
      url: '/admin/dashboard',
      children: [{
        iconUrl: 'el-icon-document',
        id: 11,
        name: '管理首页',
        url: '/admin/dashboard/home',
        children: []
      }, {
        iconUrl: 'el-icon-document',
        id: 12,
        name: '帐户信息',
        url: '/admin/dashboard/account',
        children: []
      }]
    },
    {
      iconUrl: 'el-icon-document',
      id: 2,
      name: '认证',
      url: '/admin/auth',
      children: [
        {
          iconUrl: 'el-icon-document',
          id: 21,
          name: '认证运输公司',
          url: '/admin/auth/company',
          children: []
        },
        {
          iconUrl: 'el-icon-document',
          id: 22,
          name: '认证托运人',
          url: '/admin/auth/shipper',
          children: []
        },
        {
          iconUrl: 'el-icon-document',
          id: 23,
          name: '认证经纪人',
          url: '/admin/auth/agent',
          children: []
        }
      ]
    }
  ]
}
// mutations
const mutations = {
  SET_JUDGE_ROUTE_SHOW_OBJ: (state, showObj) => {
    localStorage.setItem('routeShowObj', JSON.stringify(showObj))
    state.judgeRouteShowObj = showObj
  },
  SET_SHOW_LOCK: (state, showLock) => {
    sessionStorage.setItem('showLock', showLock)
    state.showLock = showLock
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_ISAGENT: (state, isAgent) => {
    state.isAgent = isAgent
    setCookie('isAgent', isAgent)
  },
  SET_BREADCRUMB: (state, breadcrumb) => {
    state.breadcrumb = breadcrumb
  },
  SET_AGENTINFO: (state, agentInfo) => {
    state.agentInfo = agentInfo
    setLocalStorage('agentInfo', JSON.stringify(agentInfo))
  },
  SET_USERENT: (state, userEnt) => {
    state.userEnt = userEnt
    setLocalStorage('userEnt', JSON.stringify(userEnt))
  },
  SET_SCOPEID: (state, scopeId) => {
    state.scopeId = scopeId
    setLocalStorage('scopeId', scopeId)
  },
  SET_ALLMENU_CHILDREN: (state, obj) => {
    state.sidebarMenu = obj
    // localStorage.setItem()
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
    setLocalStorage('userInfo', JSON.stringify(userInfo))
  },
  SET_USERENTLIST: (state, userEntList) => {
    state.userEntList = userEntList
    setLocalStorage('userEntList', JSON.stringify(userEntList))
  },
  SET_SIDEBARMENU: (state, sidebarMenu) => {
    state.sidebarMenu = sidebarMenu
    setLocalStorage('sidebarMenu', JSON.stringify(sidebarMenu))
  },
}
const actions = {
  setAllMenuChildren({ commit, state }, obj) {
    let routeObj = JSON.parse(JSON.stringify(state.sidebarMenu))
    routeObj = obj.value
    commit('SET_ALLMENU_CHILDREN', routeObj)
  },
  // 设置面包屑
  setBreadcrumb({ commit, state }, breadcrumb) {
    commit('SET_BREADCRUMB', breadcrumb)
  },
  setScopeId({ commit, state }, scopeId) {
    commit('SET_SCOPEID', scopeId)
  },
  // 获取用户所有企业
  getUserEntList({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      if (state.isAgent && state.isAgent !== '0') {
        dispatch('getAgentInfo').then((data) => {
          resolve(data)
        })
      } else {
        getUserEntList({}).then(response => {
          const { data } = response
          if (data && data.length > 0) {
            // 如果是外部链接参数指定的企业ID，优先用外部指定的去认证
            if (state.scopeId) {
              const entIdInfo = data.find(item => item.id == state.scopeId)
              if (entIdInfo) {
                commit('SET_USERENT', entIdInfo)
              }
              resolve(data)
              return
            } else {
              // 查询是否有已认证的非运营企业
              const entInfoOther = data.find(item => item.reviewStatus === 10 && item.type !== 1)
              // 查询运营端企业
              const entInfoAdmin = data.find(item => item.type === 1)
              const token = state.token
              // 运营端
              if (entInfoAdmin) {

                // dispatch('resetToken').then(() => {
                location.href = `${config.adminURL}?token=${token}`
                // })

              } else if (entInfoOther) {
                if (entInfoOther.type === 2) {
                  // 如果存在已认证托运企业则直接跳转到对应系统

                  location.href = `${config.shipperURL}?token=${token}`
                  resolve(entInfoOther)
                } else {
                  // 如果存在已认证运输企业则直接跳转到对应系统
                  // dispatch('resetToken').then(() => {
                  location.href = `${config.carrierURL}?token=${token}`
                  resolve(entInfoOther)
                  // })
                }
                // resolve(data)

              } else {
                commit('SET_USERENT', data[0])
                resolve(data)
              }
            }

            commit('SET_USERENTLIST', data)
          } else {
            resolve(data)
          }
        }).catch(error => {
          reject(error)
        })
      }
    })
  },
  // 获取经纪人信息
  getAgentInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      agentDetail({}).then(response => {
        const { data } = response
        if (data) {
          if (data.reviewStatus === 10) {
            // 临时测试
            const token = state.token
            location.href = `${config.agentURL}?token=${token}`
            // commit('SET_AGENTINFO', data)
            // resolve(data)
          } else {
            commit('SET_AGENTINFO', data)
            resolve(data)
          }
        } else {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo({}).then(response => {
        const { data } = response
        // data.roles = state.roles
        commit('SET_ROLES', ['admin'])
        commit('SET_USERINFO', data)
        data.roles = state.roles
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 更新TOKEN
  updateToken({ commit, state }, token) {
    commit('SET_TOKEN', token)
  },
  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {

        dispatch('resetToken')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 重置TOKEN,清理缓存
  resetToken({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      commit('SET_USERINFO', '')
      commit('SET_SCOPEID', '')
      commit('SET_SIDEBARMENU', [])
      commit('SET_USERENT', '')
      commit('SET_USERENTLIST', [])
      commit('SET_SHOW_LOCK', 0)
      commit('SET_AGENTINFO', '')
      commit('SET_ISAGENT', '')
      removeToken()
      removeLocalStorage('scopeId')
      removeLocalStorage('userInfo')
      removeLocalStorage('sidebarMenu')
      removeLocalStorage('userEnt')
      removeLocalStorage('userEntList')
      removeCookie('isAgent')
      removeLocalStorage('agentInfo')
      dispatch('tagsView/delAllViews', null, { root: true })
      resolve()
    })
  },
  // 设置当前主菜单ID
  setSidebarMenu({ commit, state }, sidebarMenu) {
    commit('SET_SIDEBARMENU', sidebarMenu)
  },
}
const getters = {
  // 获取区域大全列表
  allMenu: state => {
    return state.allMenu
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    tagsView
  }
}



// WEBPACK FOOTER //
// ./src/store/module/admin.js